var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSharedSwitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0929 16.8519C6.82012 16.8519 4.16699 14.1987 4.16699 10.9259C4.16699 7.65313 6.82012 5 10.0929 5",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26777 3.23223L11.0355 5L9.26777 6.76777",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6139 8.35625C15.6914 8.52197 15.7599 8.69526 15.8284 8.86856C15.8558 8.93787 15.8825 9.01549 15.9099 9.08481C15.9304 9.1368 15.9517 9.18049 15.9639 9.23175L15.9769 9.27471L16.9632 8.9009C16.6291 7.84512 16.0783 6.90785 15.3248 6.11728C15.1239 5.90651 14.7913 5.91241 14.5821 6.11492C14.5632 6.13318 14.5443 6.15149 14.5254 6.16984C14.3414 6.3483 14.335 6.64265 14.5184 6.82163C14.9719 7.27955 15.3442 7.80565 15.6049 8.36383L15.6139 8.35625Z",
    fill: "#20242E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0739 10.4073L16.858 10.3884C16.5819 10.3894 16.3065 10.382 16.0228 10.3739L16.0192 10.4154L16.0154 10.6493C16.0053 10.7656 16.0117 10.8832 16.0023 10.9912C15.9855 11.3745 15.934 11.7715 15.8237 12.1718C15.7366 12.4987 15.6057 12.847 15.42 13.249C15.3885 13.3216 15.3571 13.3941 15.3257 13.4666L15.3047 13.515L16.2628 13.9418C16.8362 12.8375 17.1075 11.6483 17.0739 10.4073Z",
    fill: "#20242E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2436 16.0838L12.0447 16.1584C12.0447 16.1584 12.0364 16.1577 12.0281 16.1569C12.1582 16.4862 12.2801 16.8147 12.4026 17.135C13.5896 16.762 14.6248 16.1164 15.4818 15.2126L14.7625 14.447L14.7076 14.5008C14.6166 14.5848 14.5346 14.6613 14.4436 14.7454C14.033 15.1361 13.5769 15.4726 13.0693 15.7294C12.8064 15.8653 12.5209 15.9742 12.2526 16.0762L12.2436 16.0838Z",
    fill: "#20242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharedSwitch);
export default __webpack_public_path__ + "static/media/ic-shared-switch.58c7b2b79f87819e9fd575f07ab93c85.svg";
export { ForwardRef as ReactComponent };